import { render } from "./Import.vue?vue&type=template&id=6f694950"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=6f694950&lang=scss"
script.render = render

export default script